export default "__VITE_ASSET__a7yO$Df8__"